import { render, staticRenderFns } from "./PaginatedTable.vue?vue&type=template&id=5feebde5&scoped=true&"
import script from "./PaginatedTable.vue?vue&type=script&lang=js&"
export * from "./PaginatedTable.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedTable.vue?vue&type=style&index=0&id=5feebde5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feebde5",
  null
  
)

export default component.exports